import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TEmployeesListResData,
  TEmployeesListReqParams,
  TUpdateEmployeesReqData,
  TCreateEmployeesReqData,
  TUpdateEmployeesResData,
  TCreateEmployeesResData,
  TCounterpartyBranchEmployeesResData,
  TCounterpartyBranchesReqParams
} from '../types/employees.types';

export const getCounterpartyEmployeesListService = async (
  params: TEmployeesListReqParams,
  counterpartyGUID: string
): Promise<TEmployeesListResData> => {
  const url = API_ENDPOINTS.EMPLOYEES.COUNTERPARTY_EMPLOYEES.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = {
      params,
    };
  const res = await apiClient.get<TEmployeesListResData>(url, config);

  return res.data;
};

export const createEmployeeService = async (
  counterpartyGUID: string,
  data: TCreateEmployeesReqData
): Promise<TCreateEmployeesResData> => {
  const url = API_ENDPOINTS.EMPLOYEES.COUNTERPARTY_EMPLOYEES.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TCreateEmployeesResData>(url, data);

  return res.data;
};

export const updateEmployeeService = async (
  counterpartyGUID: string,
  employee_guid: string,
  data: TUpdateEmployeesReqData
): Promise<TUpdateEmployeesResData> => {
  const url = API_ENDPOINTS.EMPLOYEES.COUNTERPARTY_EMPLOYEE_UPDATE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.EmployeeGuid, employee_guid);
  const res = await apiClient.put<TUpdateEmployeesResData>(url, data);

  return res.data;
};

export const counterpartyGetBranchEmployeesService = async (
  counterpartyGUID: string,
  branchGUID: string,
  params?: TCounterpartyBranchesReqParams
): Promise<TCounterpartyBranchEmployeesResData> => {
  const url = API_ENDPOINTS.EMPLOYEES.COUNTERPARTY_BRANCH_EMPLOYEES
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.BranchGuid, branchGUID)
  const config = {
    params,
  };
  const res = await apiClient.get<TCounterpartyBranchEmployeesResData>(url, config);

  return res.data;
};
